import { AUTH_BASE_URL, IS_AUTH_MOCK } from "./config";
import { request } from "./http";

/**
 * Self-service password reset. Uses the auth base URL (which may be separate
 * from the general API base). In preview mode these resolve optimistically so
 * the flow is still demonstrable.
 */

export interface RequestResetResult {
  requested: boolean;
}

export interface ResetResult {
  reset: boolean;
}

export function requestPasswordReset(email: string): Promise<RequestResetResult> {
  if (IS_AUTH_MOCK) return Promise.resolve({ requested: true });
  return request<RequestResetResult>("/auth/forgot-password", {
    method: "POST",
    body: { email },
    baseUrl: AUTH_BASE_URL,
  });
}

export function resetPassword(token: string, password: string): Promise<ResetResult> {
  if (IS_AUTH_MOCK) return Promise.resolve({ reset: true });
  return request<ResetResult>("/auth/reset-password", {
    method: "POST",
    body: { token, password },
    baseUrl: AUTH_BASE_URL,
  });
}